export default "__VITE_ASSET__mY_5mmmR__"